import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Layout from "../layouts/blog"

import Bio from '../components/Bio'
import SignUp from '../components/book/SignUp'
import { rhythm, scale } from '../utils/typography'

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.contentfulPost
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')
    const { previous, next } = this.props.pageContext

    return (
      <Layout location={this.props.location}>
        <div>
          <Helmet title={`${post.title} | ${siteTitle}`} />
          <h1>{post.title}</h1>
          <p
            style={{
              ...scale(-1 / 5),
              display: 'block',
              marginBottom: rhythm(1),
              marginTop: rhythm(-1),
            }}
          >
            {new Date(post.createdAt).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
            —{post.text.childMarkdownRemark.timeToRead} min read
          </p>
          <div dangerouslySetInnerHTML={{ __html: post.text.childMarkdownRemark.html }} />
          {/* <hr
            style={{
              marginBottom: rhythm(1),
            }}
          /> */}
          <SignUp additionalText="Want to read the Ultimate Guide to Quora Marketing? "/>
          <Bio />

          <ul
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
              listStyle: 'none',
              padding: 0,
            }}
          >
            {previous && (
              <li>
                <Link to={`blog/${previous.slug}`} rel="prev">
                  ← {previous.title}
                </Link>
              </li>
            )}

            {next && (
              <li>
                <Link to={`blog/${next.slug}`} rel="next">
                  {next.title} →
                </Link>
              </li>
            )}
          </ul>
        </div>
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    contentfulPost(slug: { eq: $slug }) {
      id
      createdAt,
      title,
      slug,
      text {
        childMarkdownRemark {
            html,
            timeToRead
          }
      }
    }
  }
`
